module.exports = "/lucky-balls/img/weager/balls/normal/LB_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/normal/LB_1.png
// module id = 1184
// module chunks = 0